import { useCallback, useEffect, useRef, useState } from "react";

const copyTextToClipboard = async (text) => {
    if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }
    // fallback if navigator is not available
    const input = document.createElement("input");
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
};

const useCopyToClipboard = ({ resetAfterMs = 1500 } = {}) => {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => () => {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }
    }, []);

    const copy = useCallback(async (valueOrFunc) => {
        const value = typeof valueOrFunc === "function" ? valueOrFunc() : valueOrFunc;

        try {
            await copyTextToClipboard(value);
            setCopied(true);

            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }

            if (resetAfterMs > 0) {
                timeoutRef.current = window.setTimeout(() => {
                    setCopied(false);
                }, resetAfterMs);
            }

            return true;
        } catch (error) {
            setCopied(false);
            return false;
        }
    }, [resetAfterMs]);

    return { copied, copy };
};

export default useCopyToClipboard;
